export const API_HOST =
  // @ts-ignore
  process.env["NODE_ENV"] === "production"
    ? "https://api.breathein.net"
    : "http://localhost:8001"
// : "https://brea-th.ngrok.io"

export const API_BASE_URL = `${API_HOST}/api/v1/`
